export const CARD_STYLES = `
  relative
  p-4
  pb-6
  m-1
  flex
  flex-col
  items-center
  text-center
  cursor-pointer
  outline
  outline-2
  rounded-xl
  transition-all
  duration-300
  hover:outline-cisco-blue-60
  hover:bg-cisco-blue-10
`;

export const CARD_COLORS = [
  'outline-magenta-20/75 bg-magenta-10/25',
  'outline-orange-20/75 bg-orange-10/25',
  'outline-green-20/75 bg-green-10/25',
  'outline-yellow-20/75 bg-yellow-5/25',
  'outline-red-20/75 bg-red-10/25',
  
];

export const CARD_COLORS_HIGHLIGHT = [
  'outline-magenta-50 bg-cisco-blue-10',
  'outline-orange-50 bg-cisco-blue-10',
  'outline-green-50 bg-cisco-blue-10',
  'outline-yellow-50 bg-cisco-blue-10',
  'outline-red-50 bg-cisco-blue-10',
];

export const LIST_HEADING_STYLES = "text-lg font-bold text-cisco-blue-60";